import { render, staticRenderFns } from "./formAccount.vue?vue&type=template&id=4ae83086&scoped=true&"
import script from "./formAccount.vue?vue&type=script&lang=ts&"
export * from "./formAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae83086",
  null
  
)

export default component.exports